/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import zIndexScale from '../utils/zIndexScale';

const ColorBar = styled.div.attrs(({ backgroundColor, width }) => ({
  style: {
    backgroundColor,
    width,
  },
}))`
  height: 96%;
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  background-color: red;
  z-index: ${zIndexScale.depthBar};
`;

export type Props = {
  width: number,
  backgroundColor: string,
}

export default (props: Props) => (
  <ColorBar backgroundColor={props.backgroundColor} width={props.width} />
);
